var axios = require('axios');

var axiosInstance = axios.create({
  // baseURL: "http://localhost:5000/lucid-mbti-soulmate/asia-northeast1/api",
  baseURL: "https://asia-northeast1-lucid-mbti-soulmate.cloudfunctions.net/api",
});

module.exports = axiosInstance;